import Lottie from "./Lottie";
import data from "./Tubes.json";

export default Lottie(data);
